import * as types from './Snackbar.types';

export const showSnackbar = data => ({
  type: types.SHOW_SNACKBAR,
  data
});
export const hideSnackbar = () => ({ type: types.HIDE_SNACKBAR });
